import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { CustomerProjectsWorkSheetsDataGrid } from '../../../components/datagrid/CustomerProjectsWorkSheetsDataGrid';
import { WorkSheet } from '../../../types/workSheet.types';
import { isNilOrEmpty } from '../../../utils/ramdaUtils';
import { ITab, swrConfig } from '../../Assets/AssetsEdit';
import useSWR from 'swr';
import { API_URL, fetcher } from '../../../utils/apiUrl';
import moment from 'moment';
import { MomentDateTimeSecondsSerializationFormat } from '../../../utils/dates.types';

interface Props extends ITab {
  id: string;
  customerProjectId?: number;
  filterData: CustomerProjectsTasksWorkSheetsFilterData;
  setFilterData: (filterData: CustomerProjectsTasksWorkSheetsFilterData) => void;
}

export interface CustomerProjectsTasksWorkSheetsFilterData {
  dateFrom?: string | null;
  dateTo?: string | null;
}


export const CustomerProjectsWorkSheetsTab = ({ id, active, customerProjectId, filterData, setFilterData }: Props) => {
  const history = useHistory();

  const { data: workSheets } = useSWR<WorkSheet[]>(
    `${API_URL.WORKSHEET_LIST_FOR_CUSTOMER_PROJECT}?customerProjectId=${id}${filterData.dateFrom ? `&filterFrom=${filterData.dateFrom}` : ''}${filterData.dateTo ? `&filterTo=${filterData.dateTo}` : ''}`, fetcher, swrConfig,
  );

  const handleEditButton = (e): void => {
    if (!isNilOrEmpty(e.row) && !isNilOrEmpty(e.row.data)) {
      history.push(`/workSheets/edit/${e.row.data.id}`);
    }
  };

  return (
    <>
      {workSheets && <CustomerProjectsWorkSheetsDataGrid
        data={workSheets}
        handleEdit={handleEditButton}
        customerProjectId={customerProjectId}
        filterData={filterData}
        onDateFromChanged={(dateFrom: string | null) => {
          setFilterData({ ...filterData, dateFrom: dateFrom ? moment(dateFrom).startOf('day').format(MomentDateTimeSecondsSerializationFormat) : null });
        }}
        onDateToChanged={(dateTo: string | null) => {
          setFilterData({ ...filterData, dateTo: dateTo ? moment(dateTo).endOf('day').format(MomentDateTimeSecondsSerializationFormat) : null });
        }}
      />}
    </>

  );
};
